import React from 'react';
import { MockupCrop } from '../MockupCrop';
import { Accent, SectionHeading } from './SectionHeading';
import { volumes } from '../../data/content';
import { volumesBand } from '../../data/images';

/** Section 4 — the six core volumes presented together, no bonuses. */
export function SystemSection() {
  return <section aria-labelledby="system-heading" className="bg-brand-ivory px-5 py-16 lg:px-8 lg:py-24" data-id="element-195" data-mp="39ahy165e3ng5">
      <div className="mx-auto max-w-6xl" data-id="element-196" data-mp="uoh4q75c9yk">
        <SectionHeading id="system-heading" eyebrow="The 6 Core Volumes" title={<>
              Meet Your Complete <Accent data-id="element-198" data-mp="3n86iwdzgiul7">Makeup Teaching System</Accent>
            </>} body="Six professional volumes. One connected educational workflow." data-id="element-197" data-mp="vzjqmouvbo3" />

        <div className="mt-12 hidden rounded-[28px] bg-white p-5 shadow-[0_50px_100px_-50px_rgba(59,27,87,0.45)] md:block" data-id="element-199" data-mp="jshgxjmh43rq">
          <MockupCrop crop={volumesBand} alt="The six core volumes of Makeup Instructor Ready side by side" className="rounded-[18px]" data-id="element-200" data-mp="ojhemr3f2pva" />
          <ol className="mt-5 grid grid-cols-6 gap-3 text-center" data-id="element-201" data-mp="2i2ej01x7ru15">
            {volumes.map(volume => <li key={volume.number} data-id="element-202" data-mp="2vu2zehehx4nx">
                <p className="font-body text-[11px] uppercase tracking-[0.18em] text-brand-charcoal/50" data-id="element-203" data-mp="2vv47qe44nd1y">
                  Volume {volume.number}
                </p>
                <p className="mt-1 font-display text-[1.45rem] font-bold italic text-brand-plum" data-id="element-204" data-mp="35qxsulvwwevc">{volume.stage}</p>
              </li>)}
          </ol>
        </div>

        <ol className="mt-12 grid grid-cols-2 gap-x-4 gap-y-6 md:hidden" data-id="element-205" data-mp="3es5fu7sz9ta4">
          {volumes.map(volume => <li key={volume.number} className="text-center" data-id="element-206" data-mp="3aqah9b2flu01">
              <MockupCrop crop={volume.crop} alt={`Volume ${volume.number} cover — ${volume.title}`} className="rounded-[14px] shadow-[0_20px_40px_-24px_rgba(59,27,87,0.5)]" data-id="element-207" data-mp="3aopitaczxqww" />
              <p className="mt-3 font-body text-[11px] uppercase tracking-[0.18em] text-brand-charcoal/50" data-id="element-208" data-mp="3fi2hx21w72bt">
                Volume {volume.number}
              </p>
              <p className="font-display text-[1.35rem] font-bold italic text-brand-plum" data-id="element-209" data-mp="3kigtgu2pcuel">{volume.stage}</p>
            </li>)}
        </ol>
      </div>
    </section>;
}